import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { IRelevanceState, RelevanceTypes } from './types'
import {
    failure,
    IActionType,
    request,
    success,
} from '../root.types'
import { Map } from '../../application/models/map/map'

const INITIAL_STATE: IRelevanceState = {
    list: {
        relevance: [],
        loading: false,
        error: false,
        success: false,
    }
}


export const loadRelevanceRequest = (state: IRelevanceState = INITIAL_STATE) => {
    return { ...state, list: request({ ...state.list, loading: true }) }
}

export const loadRelevanceSuccess = (state: IRelevanceState = INITIAL_STATE,
    action: IActionType<{ data: Map[] }>) => {
    const { data } = action.payload

    return { ...state, list: success({ ...state.list, relevance: data }) }
}

export const loadRelevanceFailure = (state: IRelevanceState = INITIAL_STATE) => {
    return { ...state, list: failure(state.list) }
}
const reducer: Reducer<IRelevanceState> = createReducer<IRelevanceState>(INITIAL_STATE, {
    [RelevanceTypes.LOAD_RELEVANCE_REQUEST]: loadRelevanceRequest,
    [RelevanceTypes.LOAD_RELEVANCE_SUCCESS]: loadRelevanceSuccess,
    [RelevanceTypes.LOAD_RELEVANCE_FAILURE]: loadRelevanceFailure
})
export default reducer    